import { Illustration } from "@atoms";

export const HaNResultListEmpty = ({ text }: { text: string }) => {
  return (
    <div className="flex flex-auto flex-col items-center justify-center gap-4 p-8">
      <Illustration illustration="noResults" />
      <p className="text-center">{text}</p>
    </div>
  );
};
